<ng-template #addContainer>
  <div id="addDoc">
    <div class="row page-header">
      <div class="title-header d-flex align-items-center">
        <div class="add-container"></div>
        {{title | translate}}
      </div>
    </div>
    <div class="row content">
      <div class="form-group col-md-12">
        <a (click)="onSelectAll()" class="text-link">{{'Select All' | translate}}</a>
        <input hidden>
      </div>
        <div class="col-md-12">
          <div class="row tb-checkbox">
            <div
              class="col-md-6 form-group"
              *ngFor="let ct of containers; index as i"
            >
              <div class="cont">
                <div class="cont__label">
                  <!-- <label>{{'Cargo No {i}' | translate:{i: i + 1} }}:</label> -->
                  <b>{{ct}}</b>
                </div>
                <mat-checkbox
                  color="primary"
                  [checked]="addedConainersIndex.includes(i)"
                  (change)="onCheckChange($event, i)"
                ></mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="btn-group text-right">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="onCancel()"
            >{{'Cancel' | translate}}</button>
            <button
              type="button"
              class="btn btn-primary btn-save"
              (click)="onAdd()"
              [disabled]="!addedConainersIndex.length"
            >
              <span *ngIf="!saving">{{'Add' | translate}}</span>
              <div
                *ngIf="saving"
                class="spinner-border"
                role="status"
              ></div>
            </button>
          </div>
        </div>
    </div>
  </div>
</ng-template>
